import React from 'react';
import { withStyles, Grid, Typography, ButtonBase } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import Apis from '../../network/Apis';

const TIPS_ICON = require("../../images/icons/ic_home_news.png");


class Broadcast extends React.Component {

    static JUMP_TYPE_H5 = 1;
    static JUMP_TYPE_ANCHOR = 2;
    static JUMP_TYPE_MATCH = 3;


    constructor(props) {
        super(props);
        this.state = {
            shuffData: [],
            index: 0,
        }
    }

    componentDidMount() {
        this.getTxtShuff();
        this.timer = setInterval(() => {
            let index = this.state.index;
            this.setState({ index: ++index })
        }, 10000);
    }

    componentWillUnmount() {
        this.setState = () => false;
        this.timer && clearInterval(this.timer);
    }

    getTxtShuff = async () => {
        let result = await Apis.encryptionTxtShuff();
        console.log('getTxtShuff', result);
        if (result.code == 200) {
            this.setState({ shuffData: result.data });
        }
    }


    _handleClick = () => {
        let { index, shuffData } = this.state;
        let item = shuffData[index];
        if (item) {
            if (item.jump_type == Broadcast.JUMP_TYPE_H5) {
                window.location.href = item.jump_url;
            } else if (item.jump_type == Broadcast.JUMP_TYPE_ANCHOR) {
                this.props.history.push({ pathname: '/play/' + item.jump_room_id + '/' + item.type_id + '/' + item.jump_event_id, data: item });
            } else if (item.jump_type == Broadcast.JUMP_TYPE_ANCHOR) {
                this.props.history.push({ pathname: '/play/' + item.jump_room_id + '/' + item.type_id + '/' + item.jump_event_id, data: item });
            }
        }
    }

    render() {
        const { classes } = this.props;
        const { shuffData } = this.state;
        let curShuff = '';
        if (shuffData.length > 0) {
            if (this.state.index >= shuffData.length) {
                this.state.index = 0;
            }
            curShuff = shuffData[this.state.index];
        }
        return (
            <ButtonBase disableRipple onClick={() => this._handleClick()} className={classes.button} >
                <Grid container direction='row' alignItems='center' className={classes.root}>
                    <img src={TIPS_ICON} className={classes.icon} />
                    <Grid container direction='row' alignItems='center' className={classes.container}>
                        <Typography noWrap={true} className={classes.text}>{curShuff.title} </Typography>
                        <ChevronRightOutlinedIcon className={classes.chevron} />
                    </Grid>
                </Grid>
            </ButtonBase>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100vw',
        margin: theme.spacing(1, 0, 1, 0),
    },
    container: {
        backgroundColor: '#F6F6F6',
        flex: 1,
        height: 25,
        borderRadius: 12.5,
        maxWidth: 'calc(100vw - 72px)'
    },
    icon: {
        width: 48,
        height: 18,
        padding: 0,
        margin: 0,
        margin: theme.spacing(0, 1, 0, 1),
        objectFit: 'scale-down'
    },
    chevron: {
        fontSize: 16,
        color: theme.palette.common.default,
        margin: theme.spacing(0, 1, 0, 1),
    },
    text: {
        fontSize: 11,
        color: theme.palette.common.default,
        flex: 1,
        textAlign: 'left',
        margin: theme.spacing(0, 1, 0, 1),
    },
    button: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
    }

}))(Broadcast));